var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleCalendar = function SvgGoogleCalendar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27890_78878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4213 7.58158L16.8424 6.7395L7.57922 7.58158L6.73698 16.0027L7.57906 24.4238L16.0002 25.4765L24.4213 24.4238L25.2634 15.7923L24.4213 7.58158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0324 20.6437C10.4029 20.2185 9.96709 19.5975 9.72917 18.7764L11.1903 18.1743C11.3229 18.6796 11.5545 19.0711 11.885 19.349C12.2135 19.6269 12.6135 19.7637 13.0809 19.7637C13.5588 19.7637 13.9693 19.6185 14.3124 19.3279C14.6554 19.0373 14.8282 18.6668 14.8282 18.2184C14.8282 17.7596 14.6471 17.3847 14.285 17.0943C13.9229 16.8039 13.4682 16.6584 12.925 16.6584H12.0809V15.2122H12.8386C13.306 15.2122 13.6997 15.086 14.0197 14.8333C14.3397 14.5807 14.4997 14.2354 14.4997 13.7954C14.4997 13.4039 14.3565 13.0922 14.0703 12.8586C13.7841 12.625 13.4218 12.5071 12.9818 12.5071C12.5524 12.5071 12.2113 12.6209 11.9586 12.8503C11.706 13.0797 11.5228 13.3618 11.4071 13.6945L9.96085 13.0924C10.1524 12.5492 10.5041 12.0692 11.0197 11.6545C11.5356 11.2397 12.1945 11.0312 12.9945 11.0312C13.586 11.0312 14.1186 11.145 14.5903 11.3745C15.0618 11.6039 15.4324 11.9218 15.6997 12.326C15.9671 12.7322 16.0997 13.1871 16.0997 13.6922C16.0997 14.2081 15.9756 14.6437 15.7271 15.0017C15.4786 15.3596 15.1733 15.6332 14.8113 15.8248V15.9111C15.2892 16.1111 15.6786 16.4164 15.986 16.8269C16.2913 17.2375 16.4449 17.7281 16.4449 18.3007C16.4449 18.8733 16.2996 19.3848 16.009 19.8333C15.7185 20.2818 15.3164 20.6354 14.8069 20.8922C14.2954 21.149 13.7207 21.2796 13.0828 21.2796C12.3439 21.2817 11.6618 21.069 11.0324 20.6437Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 13.3931L18.4036 14.5531L17.6016 13.3363L20.4795 11.2605H21.5827V21.052H19.9995V13.3931Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4211 32.0025L32 24.4237L28.2106 22.7395L24.4211 24.4237L22.737 28.2131L24.4211 32.0025Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89583 28.2113L7.57999 32.0008H24.4221V24.4219H7.57999L5.89583 28.2113Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52624 0C1.13056 0 0 1.13056 0 2.52624V24.421L3.78944 26.1051L7.57888 24.421V7.57888H24.421L26.1051 3.78944L24.4211 0H2.52624Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.4219V29.4745C0 30.8704 1.13056 32.0008 2.52624 32.0008H7.57888V24.4219H0Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4219 7.57991V24.422H32.0008V7.57991L28.2113 5.89575L24.4219 7.57991Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0008 7.57888V2.52624C32.0008 1.1304 30.8702 0 29.4745 0H24.4219V7.57888H32.0008Z",
    fill: "#1967D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27890_78878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "google-calendar.371059a484b7c9737ea982a298a8945e.svg";